import React from "react";
import H6 from "../Headings/H6Element";
const CustomModalHeader = (props) => {
  return (
    <div className="common-modal-header">
        <H6><span></span><span>{props.children}</span></H6>
        <button type="button" className="btn-close" aria-label="Close" onClick={props.toggle}></button>
    </div>
  );
};

export default CustomModalHeader;
